export default __webpack_public_path__ + "static/media/youtube.46bb1b54.svg";